<template>
  <div v-if="!showDetails">
    <div v-if="isMobile">
      <app-history v-for="index in history.length" :key="index" :index="index - 1" :item="history[index - 1]"
        :selectedItem="selectedItem" @clicked="onClickItem" @removeRequest="removeRequest" @callDownload="callDownload"
        @showArzyabi="showArzyabi">
      </app-history>
    </div>
    <div v-else>
      <v-data-table :items="history" item-key="Fserial" :headers="historyHeaders" class="elevation-1 rounded"
        :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText" show-expand>
        <template v-slot:[`item.Removable`]="{ item }">
          <v-btn class="grid" v-if="item.Removeable" color="red white--text" rounded
            @click="removeRequest(item.Fserial)">
            حذف درخواست
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>توضيحات متقاضی: </b>
            <span v-html="item.StudentComment"></span>
            <span v-html="' '"></span>
            <a v-if="item.HasStudentFile" @click="callDownload(item.Fserial, item.HashToken)">دریافت پیوست</a>
            <br />
            <br />
            <b> بررسی شرایط اولیه صدور مجوز تدریس: </b>{{ item.Amoozesh1State }}.
            {{ item.Amoozesh1Comment }}
            <br />
            <br />
            <b> اطلاعات مربوط به ارزیابی: </b>
            <div class="indent" v-if="item.KRequest == 'False'">
              <br />
              تاریخ مصاحبه: {{ item.DAzmoon }}
              <br />
              زمان مصاحبه: {{ item.TAzmoon }}
              <br />
              مکان مصاحبه: {{ item.LAzmoon }}
            </div>

            <template v-if="item.KRequest == 'True'">
              <br />
              <br />
              <b>مشاهده نتایج ارزیابی: </b>
              <div class="indent">
                <template v-if="item.Form1Serial != '0'">
                  <br />
                  <a @click="showArzyabi(item.Form1Serial)">
                    نتایج ارزیابی اول</a>
                  {{ item.Emtiaz1 }}
                </template>
                <template v-if="item.Form2Serial != '0'">
                  <br />
                  <a @click="showArzyabi(item.Form2Serial)">
                    نتایج ارزیابی دوم</a>
                  {{ item.Emtiaz2 }}
                </template>
                <template v-if="item.Form3Serial != '0'">
                  <br />
                  <a @click="showArzyabi(item.Form3Serial)">
                    نتایج ارزیابی سوم</a>
                  {{ item.Emtiaz3 }}
                </template>
              </div>
            </template>
            <br />
            <b>نتیجه ارزیابی: </b>{{ item.Amoozesh2State }}.
            {{ item.Amoozesh2Comment }}
            <br />
            <br />
            <b>نظر واحد حراست: </b>{{ item.TahghighatState }}.
            {{ item.TahghighatComment }}
            <br />
            <br />
            <b>نظر نهایی: </b>{{ item.Amoozesh3State }}.
            {{ item.Amoozesh3Comment }}
            <br />
            <br />
          </td>
        </template>
      </v-data-table>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
  <div v-else>
    <v-data-table :items="emtiazDetails" :headers="emtiazHeaders" class="elevation-1 rounded" :disable-pagination="true"
      :hide-default-footer="true" :no-data-text="tableText" :header-props="headerProps" :mobile-breakpoint="1024">
    </v-data-table>
  </div>
</template>

<script>
import Vue from "vue";
import History from "./History";
import Dialog from "@/components/Dialog";
import {
  removePermissionRequest,
  downloadAttach,
} from "@/api/tadris-permission";
import { saveByteArray } from "@/utils/constants";
export default {
  components: {
    appHistory: History,
    appDialog: Dialog,
  },
  data() {
    return {
      selectedItem: -1,
      showDetails: false,
      historyHeaders: [
        {
          text: "وضعیت",
          value: "StrState",
          width: "15%",
        },
        {
          text: "نوع درخواست",
          value: "StrKRequest",
          width: "20%",
        },
        {
          text: "رشته",
          value: "Reshte",
          width: "35%",
        },
        {
          text: "تاریخ درخواست",
          value: "DDate",
          width: "15%",
        },

        {
          text: "",
          value: "Removable",
          width: "15%",
          sortable: false,
        },

        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
      emtiazHeaders: [
        {
          text: "پرسش ",
          value: "Question",
          width: "35%",
        },
        {
          text: "گزینه",
          value: "Option",
          width: "15%",
        },
        {
          text: "توضیحات",
          value: "Tashrihi",
          width: "50%",
        },
      ],
      headerProps: {
        sortByText: "مرتب سازی بر اساس",
      },
    };
  },
  created() {
    this.$store.dispatch("getPermissionHistory");
  },
  computed: {
    history() {
      return this.$store.getters.tadrisPermissionHistory;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    emtiazDetails() {
      return this.$store.getters.tadrisPermissionEmtiazDetails;
    },
  },
  methods: {
    onClickItem(index) {
      if (this.selectedItem != index) {
        this.selectedItem = index;
      } else {
        this.selectedItem = -1;
      }
    },
    showArzyabi(formSerial) {

      this.$store.dispatch("getEmtiazDetails", formSerial);
      window.scrollTo(0, 0)
      this.$router.push({
        query: {

          showDetails: "true"
        }
      });
    },
    callDownload(index, token) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadAttach(index, token)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    /**
     * show confirm dialog
     */
    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        removePermissionRequest(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.$store.dispatch("getPermissionHistory");
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
  watch: {

    '$route'(to, from) {
      this.showDetails = !!this.$route.query.showDetails;

    }
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}

.indent {
  margin-right: 30px;
}
</style>
